import { connect } from "react-redux";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import HealthPolicyQuestions from "../HealthPolicyQuestions";
import DefaultConferenceQuestions from "../DefaultConferenceQuestions";
import FallOnlineQuestions from "../FallOnlineQuestions";

class RegistrationInfoPage extends PureComponent {
  static propTypes = {
    me: PropTypes.object.isRequired,
  };

  componentDidMount = () => {};

  _proofOfStudiesUploaded = () => {};

  render() {
    const { event } = this.props.me;
    if (event.conferenceType === "HealthPolicy") {
        return (
            <div>
                <HealthPolicyQuestions />
            </div>
        );
    }
    if (event.eventTitle === "2025 AANP Fall Conference (Online)") {
      return (
          <div>
              <FallOnlineQuestions />
          </div>
      );
  }
    else {
        return (
            <div>
                <DefaultConferenceQuestions />
            </div>
        );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    me: state.account.me,
  };
};

const mapDispatchToProps = {};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(RegistrationInfoPage)
);
